var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStandardSortAsc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 2L15.3333 5.33333H13.3333V13.3333H12V5.33333H10L12.6667 2ZM9.33333 12V13.3333H2V12H9.33333ZM9.33333 7.33333V8.66667H2V7.33333H9.33333ZM8 2.66667V4H2V2.66667H8Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStandardSortAsc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/standard-sort-asc.f2f5b0cd.svg";
export { ForwardRef as ReactComponent };